<template>
  <main :class="`modal modal-${size || 'sm'} ` + 'active'" v-if="active" id="modal-id">
    <a @click.prevent="close()" class="modal-overlay" aria-label="Close"></a>
    <div class="modal-container">
      <div class="modal-header">
        <a @click.prevent="close()" class="btn btn-clear float-right" aria-label="Close"></a>
        <div class="modal-title h5">{{title || ERROR_MESSAGES.modal.server.title}}</div>
      </div>
      <div class="modal-body">
        <div class="content" v-html="body || ERROR_MESSAGES.modal.server.body">
        </div>
      </div>
      <div class="modal-footer">
        <button @click.prevent="close()" class="btn btn-primary">Fechar</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: [
    'title',
    'body',
    'active',
    'size',
    'callback'
  ],
  methods: {
    close () {
      if (this.callback) {
        this.callback()
      }
      this.$store.dispatch('setModalAlert')
    }
  }
}
</script>
